// src/taxonomies/framework-identity-taxonomy.js

/* ============================================================================
   TAXONOMY — PROJECT IDENTITY (UI reference lists)
   Ne pas modifier les valeurs/labels sans impact contrôlé (templates / analytics).
============================================================================ */


export const DELIVERY_METHOD_OPTIONS = [
  { value: "WORKS_CONTRACT", label: "Marché travaux (exécution seule)" },
  { value: "LOT_SEPARATED", label: "Marchés séparés par lots" },
  { value: "DESIGN_BUILD", label: "Conception–Réalisation (Design–Build)" },
  { value: "EPC", label: "EPC – Clé en main" },
  { value: "EPCM", label: "EPCM – Management pour le client" },
  { value: "PPP", label: "PPP / Concession" }
];

export const PROJECT_GOVERNANCE_LEVEL_OPTIONS = [
  { value: "SINGLE_CLIENT", label: "Client unique (gouvernance directe)" },
  { value: "MULTI_STAKEHOLDERS", label: "Plusieurs parties décisionnelles" },
  { value: "PUBLIC_OR_STRATEGIC", label: "Projet à enjeu public / stratégique" },
  { value: "PROGRAM_MANAGEMENT", label: "Programme multi-projets coordonné" }
];


export const projectTypeOptions = [
  { value: "BUILDING", label: "Building" },
  { value: "INFRA", label: "Infrastructure" },
  { value: "INDUSTRIAL", label: "Industrial" },
  { value: "WATER", label: "Water" },
  { value: "ENERGY", label: "Energy" },
];

export const countryOptions = [
  { value: "FR", label: "France" },
  { value: "MA", label: "Maroc" },
  { value: "SN", label: "Sénégal" },
  { value: "CI", label: "Côte d’Ivoire" },
  { value: "ES", label: "Espagne" },
  { value: "PT", label: "Portugal" },
  { value: "DE", label: "Allemagne" },
];




export const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];